"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANNEL_ERROR_CODES = exports.ClaudeChatNamespace = exports.ClaudeChannelNamespace = exports.MIN_CLAUDE_CODE_VERSION = exports.CLAUDE_CHANNEL_ENVELOPE_VERSION = void 0;
exports.isClaudeCodeVersionSupported = isClaudeCodeVersionSupported;
exports.CLAUDE_CHANNEL_ENVELOPE_VERSION = 1;
exports.MIN_CLAUDE_CODE_VERSION = "2.1.234";
exports.ClaudeChannelNamespace = "/claude-channel";
exports.ClaudeChatNamespace = "/claude-chat";
exports.CHANNEL_ERROR_CODES = [
    "unsupported_envelope",
    "version_too_old",
    "session_id_in_use",
    "auth_expired",
];
const STRICT_SEMVER = /^(\d+)\.(\d+)\.(\d+)$/;
function parseStrict(v) {
    const m = STRICT_SEMVER.exec(v);
    return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null;
}
function isClaudeCodeVersionSupported(v) {
    if (typeof v !== "string")
        return false;
    const got = parseStrict(v);
    const floor = parseStrict(exports.MIN_CLAUDE_CODE_VERSION);
    if (!got || !floor)
        return false;
    for (let i = 0; i < 3; i++) {
        if (got[i] !== floor[i])
            return got[i] > floor[i];
    }
    return true;
}
